/** Official Hello by Flow watermark — embedded 3D brand mark.
 *  Uses the true-transparency 3D asset so depth, bevels and ambient
 *  shadows read through at low opacity. Customer application only —
 *  never mounted on the Owner Console, auth, identity or public pages. */
export default function BrandWatermark() {
  return (
    <div aria-hidden="true" data-testid="brand-watermark" className="hbf-watermark">
      <img src="/brand/hbf-logo-3d-wm.png" alt="" draggable={false} />
    </div>
  );
}
